/**
 * ContractAlertBadge (Phase 6, §6.2). Colour-coded badge for a contract's
 * `alert` state, mirroring `DedupBadge.tsx`'s solid-pastel-pill style using
 * the German labels from `lib/labels`.
 */
import { CONTRACT_ALERT } from '../../lib/labels.ts';
import type { ContractAlert } from '../../lib/types.ts';

// Badge palette per DESIGN.md §3.11: solid pastel pills.
const STYLE: Record<ContractAlert, string> = {
  overdue: 'bg-rose-100 text-rose-800 dark:bg-rose-950 dark:text-rose-300',
  amount_drift: 'bg-amber-100 text-amber-800 dark:bg-amber-950 dark:text-amber-300',
};

export function ContractAlertBadge({ alert }: { alert: ContractAlert }) {
  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold ${STYLE[alert]}`}
    >
      {CONTRACT_ALERT[alert]}
    </span>
  );
}
